import { action, makeAutoObservable, observable } from 'mobx';
import { SelectItemTypes } from '../enums'; 
import { IAPISelectedItemsRequest } from '../interfaces';
import { RelatedItemsCategoriesModel } from './DonationAndItemModel';

export class SelectItemsPopupStore {
    @observable public activeTab: string = 'items';
    @observable public typeFilter: string = Object.keys(SelectItemTypes).find(
        (x) => SelectItemTypes[x as keyof typeof SelectItemTypes] == SelectItemTypes.All,
    ) as string;
    @observable public searchValue: string = '';
    @observable public items: RelatedItemsCategoriesModel[];
    @observable public selectedItem: RelatedItemsCategoriesModel;
    public inStockOnly: boolean = false;
    constructor() {
        this.items = [];
        this.selectedItem = new RelatedItemsCategoriesModel();
        makeAutoObservable(this);
    }

    toggleInStockOnly() {
        this.inStockOnly = !this.inStockOnly;
    }

    @action
    deserializeAPIModel(data: IAPISelectedItemsRequest[]) {
        this.items = RelatedItemsCategoriesModel.deserializeAPIList(data);
    }
    @action
    updateSelectedItem(type: RelatedItemsCategoriesModel) {
        this.selectedItem = new RelatedItemsCategoriesModel(type);
    }
    @action
    setActiveTab(value: string) {
        this.activeTab = value;
    }
    @action
    setSearchValue(value: string) {
        this.searchValue = value;
    }
    @action
    setTypeFilter(value: string) {
        this.typeFilter = value;
    }
}
